(function () {
  function initFeaturedCollection(section) {
    var track = section.querySelector('[data-fc-track]');
    var slides = section.querySelectorAll('[data-fc-slide]');
    var prevBtn = section.querySelector('[data-fc-prev]');
    var nextBtn = section.querySelector('[data-fc-next]');
    var dots = section.querySelectorAll('[data-fc-dot]');
    if (!track || !slides.length) return;

    var layout = section.getAttribute('data-layout');
    if (layout === 'grid') return; // no scroll nav needed in static grid mode

    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5;
    var autoplayTimer = null;
    var ticking = false;

    function scrollAmount() {
      var firstSlide = slides[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    }

    function updateActiveDot() {
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(trackCenter - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });

      updateArrowState(closestIndex);
      ticking = false;
    }

    function updateArrowState(activeIndex) {
      if (!prevBtn || !nextBtn) return;
      prevBtn.classList.toggle('is-disabled', activeIndex === 0);
      nextBtn.classList.toggle('is-disabled', activeIndex === slides.length - 1);
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveDot);
        ticking = true;
      }
    }

    function scrollByAmount(direction) {
      track.scrollBy({ left: direction * scrollAmount(), behavior: 'smooth' });
    }

    function goToSlide(index) {
      var target = slides[index];
      if (!target) return;
      var trackRect = track.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var offset = (targetRect.left + targetRect.width / 2) - (trackRect.left + trackRect.width / 2);
      track.scrollBy({ left: offset, behavior: 'smooth' });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (Math.ceil(track.scrollLeft) >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }, autoplaySpeed * 1000);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        scrollByAmount(1);
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        stopAutoplay();
        goToSlide(index);
      });
    });

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    updateActiveDot();
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.section-featured-collection').forEach(initFeaturedCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-featured-collection');
    if (section) initFeaturedCollection(section);
  });
})();